import { useMatomo } from "@jonkoops/matomo-tracker-react";
import { Link } from "react-router-dom";

function Footer() {
    const { trackEvent } = useMatomo();

    const onContactLinkClick = (type: 'tel' | 'mail') => { 
        trackEvent({ category: 'footer', action: `${type} link click` });
    }


    const landingPageLinks: LinkObj[] = [
        { href: '/#features', label: 'Features' },
        { href: '/#partners', label: 'Partners' },
        { href: '/#story', label: 'Our story' },
        { href: '/#faq', label: 'FAQ' }
    ];

    const legalLinks: LinkObj[] = [
        { href: '/privacy', label: 'Privacy' },
        { href: '/imprint', label: 'Imprint' }
    ];

    const address1 = [
        "Adress Wien",
        "3Folio GmbH",
        "Ernst Melchior Gasse 24/DG",
        "1020 Wien"
    ];

    const address2 = [
        "Adress Linz",
        "Danube Blockchain Hub",
        "Peter-Behrens-Platz 4",
        "4020 Linz"
    ];

    const phone = "+43 676 366 80 26";
    const email = "contact@3folio.finance";

    const scrollToTopOnClick = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    return (
        <footer className="bg-blue-600 p-10">
            <div className="max-w-screen-xl flex flex-row flex-wrap mx-auto">
                <div className="w-1/4 max-md:w-1/2 max-md:mb-12 max-[450px]:w-full">
                    <p className="font-bold text-left text-white">
                        Links
                    </p>
                    <ul>
                        {landingPageLinks.map((link) => (
                            <li key={link.href} className="py-1 text-white text-left">
                                <Link to={link.href}>
                                    {link.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="w-1/4 max-md:w-1/2 max-md:mb-12 max-[450px]:w-full">
                    <p className="font-bold text-left text-white">
                        Legal
                    </p>
                    <ul>
                        {legalLinks.map((link) => (
                            <li key={link.href} className="py-1 text-white text-left">
                              <Link to={link.href} onClick={scrollToTopOnClick}>
                                    {link.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="w-1/4 max-md:w-1/2 max-md:mb-12 max-[450px]:w-full">
                    <ul>
                        {address1.map((line, i) => (
                            <li key={line} className={"text-white text-left " + (i === 0 && "font-bold")} >
                                {line}
                            </li>
                        ))}
                    </ul>
                    <ul>
                        <li className={" text-white text-left font-bold mt-5"}>
                            Phone
                        </li>
                        <li className={"text-white text-left underline hover:text-slate-100"}>
                            <a href={"tel:" + phone} target="_blank" rel="noreferrer" onClick={() => onContactLinkClick('tel')}>
                                { phone }
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="w-1/4 max-md:w-1/2 max-md:mb-12 max-[450px]:w-full">
                    <ul>
                        {address2.map((line, i) => (
                            <li key={line} className={" text-white text-left " + (i === 0 && "font-bold")} >
                                {line}
                            </li>
                        ))}
                    </ul>
                    <ul>
                        <li className={" text-white text-left font-bold mt-5"}>
                            E-Mail
                        </li>
                        <li className={"text-white text-left underline hover:text-slate-100"}>
                            <a href={"mailto:" + email} target="_blank" rel="noreferrer" onClick={() => onContactLinkClick('mail')}>
                                { email }
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </footer>
    )
}

export default Footer;

interface LinkObj {
    label: string;
    href: string;
}